import { render } from "./InseeCompanyViewView.vue?vue&type=template&id=ddf9d298&scoped=true"
import script from "./InseeCompanyViewView.vue?vue&type=script&lang=js"
export * from "./InseeCompanyViewView.vue?vue&type=script&lang=js"

import "./InseeCompanyViewView.vue?vue&type=style&index=0&id=ddf9d298&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf9d298"]])

export default __exports__